import { render, staticRenderFns } from "./EmojiOrIcon.vue?vue&type=template&id=3dcb4f04&scoped=true&"
import script from "./EmojiOrIcon.vue?vue&type=script&lang=js&"
export * from "./EmojiOrIcon.vue?vue&type=script&lang=js&"
import style0 from "./EmojiOrIcon.vue?vue&type=style&index=0&id=3dcb4f04&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dcb4f04",
  null
  
)

export default component.exports